module.exports = __webpack_public_path__ + "img/no-stream-bg.63f28bf1.jpg";